
<template>
  <el-input v-model="this.localValue"
    :attrs="this.$attrs" :class="this.$style.root" @focus="this.handleFocus()"
    @blur="this.handleBlur()">

    <slot>
    </slot>
    <slot name="prefix">
    </slot>
    <slot name="suffix">
    </slot>
    <slot name="prepend">
    </slot>
    <slot name="append">
    </slot>


    <!--    {this.$slots.prefix && (
    <template slot="prefix">{this.$slots.prefix}</template>
    )}
    {this.$slots.suffix && (
    <template slot="suffix">{this.$slots.suffix}</template>
    )}
    {this.$slots.prepend && (
    <template slot="prepend">{this.$slots.prepend}</template>
    )}
    {this.$slots.append && (
    <template slot="append">{this.$slots.append}</template>
    )} -->
  </el-input>

</template>

<script>
import numeral from 'numeral'

export default {
  inheritAttrs: false,

  props: {
    value: {
      type: Number,
      required: false,
      default: undefined,
    },
    format: {
      type: String,
      required: false,
      default: '0,0.00',
    },
    min: {
      type: Number,
      required: false,
      default: undefined,
    },
    max: {
      type: Number,
      required: false,
      default: undefined,
    }
  },

  data() {
    return {
      localValue: this.value,
    }
  },

/*   watch: {
    value: {
      immediate: true,
      handler(value) {
        this.localValue =
          value !== null ? numeral(value).format(this.format) : null
      }
    }
  }, */

  methods: {
    handleFocus(e) {
      const value = numeral(this.localValue).value()

      if (value === null) return

      this.localValue = value.toString()

      this.$nextTick(() => {
        e.target.select()
      })
    },

    handleBlur() {
      let value = numeral(this.localValue).value()

      if (value === null) {
        this.$emit('input', null)
        return
      }

      if (value < this.min) {
        value = this.min
      } else if (value > this.max) {
        value = this.max
      }

      this.localValue = numeral(value).format(this.format)

      if (value !== this.value) {
        this.$emit('input', numeral(this.localValue).value())
      }

      this.localValue = numeral(this.value).format(this.format)
    }
  },

  /*render() {
    return (
      <el-input
        value={this.localValue}
        attrs={this.$attrs}
        class={this.$style.root}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onInput={value => {
          this.localValue = value
        }}
      >
        {this.$slots.prefix && (
          <template slot="prefix">{this.$slots.prefix}</template>
        )}
        {this.$slots.suffix && (
          <template slot="suffix">{this.$slots.suffix}</template>
        )}
        {this.$slots.prepend && (
          <template slot="prepend">{this.$slots.prepend}</template>
        )}
        {this.$slots.append && (
          <template slot="append">{this.$slots.append}</template>
        )}
      </el-input>
    )
  } */
}
</script>

<style lang="scss" module>
.root {
  :global(.el-input__inner) {
    text-align: right;
  }
}
</style>
